export default "__VITE_ASSET__CaTEiLEP__"